var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1Star(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55167 2.57531C9.73508 2.20372 10.265 2.20372 10.4484 2.57531L12.4588 6.6482C12.5316 6.79563 12.6722 6.89786 12.8348 6.92164L17.3315 7.57888C17.7414 7.63881 17.9048 8.14273 17.608 8.43181L14.3551 11.6002C14.2371 11.715 14.1833 11.8806 14.2111 12.0429L14.9787 16.5183C15.0488 16.9268 14.62 17.2383 14.2532 17.0454L10.2327 14.931C10.0871 14.8544 9.91299 14.8544 9.76729 14.931L5.74684 17.0454C5.38002 17.2383 4.95125 16.9268 5.02131 16.5183L5.7889 12.0429C5.81673 11.8806 5.7629 11.715 5.64496 11.6002L2.39203 8.43181C2.09523 8.14273 2.25862 7.63881 2.66858 7.57888L7.1652 6.92163C7.32788 6.89786 7.46847 6.79563 7.54124 6.6482L9.55167 2.57531Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Star);
export default __webpack_public_path__ + "static/media/1-star.3b25aef893ace2dae44d821347ba75a9.svg";
export { ForwardRef as ReactComponent };